module.exports = __webpack_public_path__ + "img/scientificIcon02.61abc9e0.png";